import React, { useState, useEffect } from 'react';
import './FAQ.css'; 

// Firebase importları
import { collection, addDoc, doc, updateDoc, deleteDoc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/firebase-config';

const FAQ = () => {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editId, setEditId] = useState(null);
  
  // Form verileri (Soru ve Cevap)
  const [formData, setFormData] = useState({ 
    question: '', 
    answer: '' 
  });

  // 1. Verileri Çek (Real-time)
  useEffect(() => {
    const faqRef = collection(db, "faqs");
    const unsubscribe = onSnapshot(faqRef, (snapshot) => {
      const faqData = snapshot.docs.map(doc => ({
        ...doc.data(),
        id: doc.id
      }));
      setFaqs(faqData);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  // Modal Açma
  const openModal = (item = null) => {
    if (item) {
      setEditId(item.id);
      setFormData({ question: item.question, answer: item.answer });
    } else {
      setEditId(null);
      setFormData({ question: '', answer: '' });
    }
    setIsModalOpen(true);
  };

  // 2. KAYDETME (Ekleme veya Güncelleme)
  const handleSave = async (e) => {
    e.preventDefault();
    try {
      if (editId) {
        // GÜNCELLEME
        const faqDoc = doc(db, "faqs", editId);
        await updateDoc(faqDoc, formData);
        alert("Soru güncellendi!");
      } else {
        // YENİ EKLEME
        const faqRef = collection(db, "faqs");
        await addDoc(faqRef, formData);
        alert("Yeni soru eklendi!");
      }
      setIsModalOpen(false);
    } catch (error) {
      console.error("Hata:", error);
      alert("Bir hata oluştu.");
    }
  };

  // 3. SİLME
  const handleDelete = async (id) => {
    if (window.confirm("Bu soruyu silmek istediğinize emin misiniz?")) {
      try {
        await deleteDoc(doc(db, "faqs", id));
      } catch (error) {
        console.error("Silme hatası:", error);
      }
    }
  };

  return (
    <div className="faq-container">
      <div className="page-header">
        <h2>Sıkça Sorulan Sorular</h2>
        <button className="add-btn" onClick={() => openModal()}>
          + Yeni Soru Ekle
        </button>
      </div>

      <div className="table-container">
        <table className="faq-table">
          <thead>
            <tr>
              <th style={{width: '30%'}}>Soru</th>
              <th>Cevap</th>
              <th style={{ width: '150px', textAlign: 'right' }}>İşlemler</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="3" style={{textAlign: 'center', padding: '20px'}}>Yükleniyor...</td></tr>
            ) : (
              <>
                {faqs.map((faq) => (
                  <tr key={faq.id}>
                    <td className="question-cell">{faq.question}</td>
                    <td className="answer-cell">{faq.answer}</td>
                    <td className="action-buttons-cell">
                      <div className="buttons-wrapper">
                        <button className="action-btn edit-btn" onClick={() => openModal(faq)}>Düzenle</button>
                        <button className="action-btn delete-btn" onClick={() => handleDelete(faq.id)}>Sil</button>
                      </div>
                    </td>
                  </tr>
                ))}
                {faqs.length === 0 && (
                  <tr><td colSpan="3" style={{textAlign: 'center', color: '#999', padding:'20px'}}>Hiç soru eklenmemiş.</td></tr>
                )}
              </>
            )}
          </tbody>
        </table>
      </div>

      {/* MODAL */}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-header">
              <h3>{editId ? 'Soruyu Düzenle' : 'Yeni Soru Ekle'}</h3>
              <button className="close-btn" onClick={() => setIsModalOpen(false)}>&times;</button>
            </div>
            <form onSubmit={handleSave}>
              <div className="form-group">
                <label>Soru Başlığı</label>
                <input 
                  type="text" 
                  required 
                  placeholder="Örn: Boşanma davası ne kadar sürer?"
                  value={formData.question} 
                  onChange={(e) => setFormData({...formData, question: e.target.value})} 
                />
              </div>
              <div className="form-group">
                <label>Cevap</label>
                <textarea 
                  required 
                  rows="5"
                  placeholder="Cevabı buraya yazın..."
                  value={formData.answer} 
                  onChange={(e) => setFormData({...formData, answer: e.target.value})} 
                />
              </div>
              <div className="modal-footer">
                <button type="button" className="cancel-btn" onClick={() => setIsModalOpen(false)}>İptal</button>
                <button type="submit" className="save-btn">Kaydet</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default FAQ;